import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=593486f4&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=ts&"
export * from "./ChatBot.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=593486f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593486f4",
  null
  
)

export default component.exports